import Crud from '../components/Role/Crud'
import Add from '../components/Role/Add'
import Edit from '../components/Role/Edit'


let routes = {
    path: '/roles',
    component: resolve => require(['../components/layout/App'], resolve),
    children: [{
        path: '/roles',
        name: 'Cargos',
        component: Crud
    },
    {
        path: '/roles/add',
        name: 'Novo Cargo',
        component: Add
    },
    {
        path: '/roles/edit/:id',
        name: 'Editar Cargo',
        component: Edit
    }
    ]
};

export default routes



// WEBPACK FOOTER //
// ./src/router/role.js